/** @jsxImportSource @emotion/react */

import { Radio, RadioChangeEvent } from "antd";
import { ReactComponent as HomeIcon } from "assets/mobile/icons/home-page/MenuUpdate/home.svg";
import { ReactComponent as PromotionIcon } from "assets/mobile/icons/home-page/MenuUpdate/promotion.svg";
import { ReactComponent as RevertIcon } from "assets/mobile/icons/home-page/MenuUpdate/revert.svg";
import { ReactComponent as SupportIcon } from "assets/mobile/icons/home-page/MenuUpdate/support.svg";
import { ReactComponent as UserIcon } from "assets/mobile/icons/home-page/MenuUpdate/user.svg";
import {
  BOTTOM_NAVIGATE_LOGGED,
  BOTTOM_NAVIGATE_UNLOGGED,
  BottomNavigateItem,
} from "constants/bottom-navigate";
import { PATH } from "constants/path";
import _find from "lodash/find";
import _map from "lodash/map";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectIsAuthenticated } from "store/auth";

import { BottomNavigateStyle } from "./index.style";

const iconBottom = [
  <HomeIcon />,
  <RevertIcon />,
  <PromotionIcon />,
  <SupportIcon />,
  <UserIcon />,
];

const BottomNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [defaultValue, setDefaultValue] = useState<BottomNavigateItem>();

  const navitateItems = useMemo(() => {
    const data = isAuthenticated
      ? BOTTOM_NAVIGATE_LOGGED
      : BOTTOM_NAVIGATE_UNLOGGED;

    setTimeout(() => {
      setDefaultValue(
        _find(navitateItems, (item) => item.path === location.pathname),
      );
    }, 10);

    return data;
  }, [isAuthenticated]);

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    if (value.id === "support") {
      window.open(value.path);
      return;
    }
    if (value.path === "#") {
      if (!isAuthenticated) {
        navigate(PATH.Account.login);
      }
      return;
    }
    navigate(value.path);
  };

  useEffect(() => {
    setDefaultValue(
      _find(navitateItems, (item) => item.path === location.pathname),
    );
  }, [location]);

  return (
    <div css={BottomNavigateStyle.self}>
      <Radio.Group
        value={defaultValue}
        buttonStyle="solid"
        onChange={onChange}
        css={BottomNavigateStyle.radioGroup}
      >
        {_map(navitateItems, (item, index) => (
          <Radio.Button
            key={index}
            value={item}
            css={BottomNavigateStyle.radioItemWrapper}
          >
            <div css={BottomNavigateStyle.radioItem}>
              {iconBottom[index]}
              <span css={BottomNavigateStyle.itemLabel}>{item.name}</span>
            </div>
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
};

export default BottomNavigate;
